module.exports = __webpack_public_path__ + "static/media/brightcream.1c53776d.png";